import {AnalysisVisualizationType} from 'analysis-tool/ui/charting/ChartingTypes';
import BenchlingConfig from 'BenchlingConfig';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import {BenchlingDuotoneIconName} from 'ui-library/icons/BenchlingDuotoneIcon';

import {
  AnalysisToolExcludedVisualizationConfigFields,
  AnalysAnalysisToolExcludedChartViewConfigFields,
} from './AnalysisChartingTypes';

export const NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE: {
  [k in VisualizationType]: Array<AnalysisToolExcludedVisualizationConfigFields>;
} = {
  [VisualizationType.BAR_CHART]: [],
  [VisualizationType.HEATMAP]: [],
  [VisualizationType.LINE_CHART]: ['outlierConfig', 'regressionConfig', 'rowIdColumnName'],
  [VisualizationType.SCATTER_PLOT]: ['outlierConfig', 'regressionConfig', 'rowIdColumnName'],
  [VisualizationType.PIE_CHART]: [],
  [VisualizationType.TABLE]: ['displayColumnsJson'],
};

export const NON_PERSISTED_GQL_FIELDS_FOR_CHART_VIEW_BY_CHART_TYPE: {
  [k in VisualizationType]: Array<AnalysAnalysisToolExcludedChartViewConfigFields>;
} = {
  [VisualizationType.BAR_CHART]: [
    ...NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.BAR_CHART],
    'aggregationType',
    'errorBarType',
  ],
  [VisualizationType.HEATMAP]: NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.HEATMAP],
  [VisualizationType.LINE_CHART]: NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.LINE_CHART],
  [VisualizationType.SCATTER_PLOT]: [
    ...NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.SCATTER_PLOT],
    'aggregationType',
    'errorBarType',
  ],
  [VisualizationType.PIE_CHART]: [
    ...NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.PIE_CHART],
    'aggregationType',
  ],
  [VisualizationType.TABLE]: NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[VisualizationType.TABLE].concat([]),
};

export const ANALYSIS_VISUALIZATION_TYPE_TO_ICON: {
  [key in AnalysisVisualizationType]: BenchlingDuotoneIconName;
} = {
  [AnalysisVisualizationType.BAR_CHART]: 'analyze',
  [AnalysisVisualizationType.BOX_PLOT]: 'chart-candlestick',
  [AnalysisVisualizationType.CONTOUR_PLOT]: 'steak',
  [AnalysisVisualizationType.HEATMAP]: 'heatmap',
  [AnalysisVisualizationType.LINE_CHART]: 'line-chart',
  [AnalysisVisualizationType.PIE_CHART]: 'pie-chart',
  [AnalysisVisualizationType.SCATTER_PLOT]: 'scatter-plot',
  [AnalysisVisualizationType.TABLE]: 'table',
};

export const ANALYSIS_VISUALIZATION_TYPE_TO_READABLE: {[key in AnalysisVisualizationType]: string} = {
  [AnalysisVisualizationType.BAR_CHART]: 'Bar chart',
  [AnalysisVisualizationType.BOX_PLOT]: 'Box plot',
  [AnalysisVisualizationType.CONTOUR_PLOT]: 'Contour plot',
  [AnalysisVisualizationType.HEATMAP]: 'Heatmap',
  [AnalysisVisualizationType.LINE_CHART]: 'Line chart',
  [AnalysisVisualizationType.PIE_CHART]: 'Pie chart',
  [AnalysisVisualizationType.SCATTER_PLOT]: 'Scatter plot',
  [AnalysisVisualizationType.TABLE]: 'Table',
};

export const MAX_DATA_POINTS = 1000;

export function getAnalysisOnlyChartViewTypes(): Array<AnalysisVisualizationType> {
  return BenchlingConfig.ENABLE_ANALYSIS_TOOL_NEW_BOXPLOT_FEATURES
    ? [
        AnalysisVisualizationType.BOX_PLOT,
        AnalysisVisualizationType.PIE_CHART,
        AnalysisVisualizationType.LINE_CHART,
      ]
    : [AnalysisVisualizationType.BOX_PLOT];
}
